import Scrollbar, {ScrollbarPlugin} from 'smooth-scrollbar';
import { $ } from './../helpers/query'

export default class {
  constructor(scrollBarElem) {
    this.scrollBar;
    this.scrollBarElem;
    if (typeof scrollBarElem == 'string') {
      this.scrollBarElem = document.querySelector(scrollBarElem);
    } else {
      this.scrollBarElem = scrollBarElem;
    }
    this.eventSlidePrev = new Event('fullpageSlidePrev');
    this.eventSlideNext = new Event('fullpageSlideNext');
  }

  init() {
    class InvertDeltaPlugin extends ScrollbarPlugin {
      static pluginName = 'invertDelta';
      static defaultOptions = {events: []};

      transformDelta(delta, fromEvent) {
        if (this.shouldInvertDelta(fromEvent)) {
          if (document.documentElement.clientWidth > 640) {
            return {x: delta.y, y: delta.x};
          } else {
            return {x: delta.x, y: delta.y};
          }
        }
        return delta;
      }

      shouldInvertDelta(fromEvent) {
        return this.options.events.some(rule => fromEvent.type.match(rule));
      }
    }

    Scrollbar.use(InvertDeltaPlugin);

    this.scrollBar = Scrollbar.init(this.scrollBarElem, {
      alwaysShowTracks: false,
      delegateTo: this.scrollBarElem.closest('.fullpage__section'),
      plugins: {invertDelta: {events: ['wheel', 'touch']}},
    });

    this.scrollBar.addListener(this.handleEvents.bind(this));

    window.addEventListener('fullpageBlocked', () => {
      this.pushFromLimit();
    });
  }

  handleEvents(e) {
    const offsetX = e.offset.x;
    const limitX = e.limit.x;

    if (offsetX === 0) {
      window.dispatchEvent(this.eventSlidePrev);
    } else if (offsetX === limitX) {
      window.dispatchEvent(this.eventSlideNext);
    }
  }

  pushFromLimit() {
    const offsetX = this.scrollBar.offset.x;
    const limitX = this.scrollBar.limit.x;
    if (offsetX === 0) {
      this.scrollBar.setPosition(1, 0);
    } else if (offsetX === limitX) {
      this.scrollBar.setPosition(limitX - 1, 0);
    }
  }

  setPosition(x) {
    this.scrollBar.scrollLeft = x;
  }
}
